import PropTypes from "prop-types";

export const HeadingCarouselProps = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  viewAllLink: PropTypes.string,
  onViewAllClick: PropTypes.func,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
};
